/* eslint-disable import/no-extraneous-dependencies */
import * as React from 'react';
import { ResponsiveHeaderNav } from '@telus-alberta-health-web/shared-module';
import { TextAction } from '@leagueplatform/genesis-core';
import { Image } from '@leagueplatform/genesis-commons';
import { useIntl } from '@leagueplatform/locales';
import { Link } from 'react-router-dom';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import logoWithText from 'assets/LogoWithText.png';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { useUserSettingsLinksConfig } from 'components/header-nav/use-user-settings-links-config.hook';
import { useNavLinksList } from './use-nav-links-list.hook';

const Logo = () => {
  const { formatMessage } = useIntl();
  return (
    <TextAction
      as={Link}
      to={APP_MANAGED_ROUTES.HOME}
      onClick={() =>
        trackAnalyticsEvent(EVENT_NAME.NAVIGATION_TAB_CLICKED, {
          screen_name: 'Navigation Bar',
          detail: 'Home',
        })
      }
    >
      <Image
        src={logoWithText}
        height="40px"
        alt={formatMessage({ id: 'STR_APP_LOGO' })}
      />
    </TextAction>
  );
};

export const AppNavBarComponent = React.memo(() => {
  const { navLinks } = useNavLinksList();
  const { userSettingsLinks } = useUserSettingsLinksConfig();

  return (
    <ResponsiveHeaderNav
      navLinks={navLinks}
      logo={<Logo />}
      userSettingsLinks={userSettingsLinks}
    />
  );
});
